<template>
  <div>     
    <span class="fa fa-star" @click="ratingclicked(1)" :class="{'ratingchecked':currentrating>0}"></span>
    <span class="fa fa-star" @click="ratingclicked(2)" :class="{'ratingchecked':currentrating>1}"></span>
    <span class="fa fa-star" @click="ratingclicked(3)" :class="{'ratingchecked':currentrating>2}"></span>
    <span class="fa fa-star" @click="ratingclicked(4)" :class="{'ratingchecked':currentrating>3}"></span>
    <span class="fa fa-star" @click="ratingclicked(5)" :class="{'ratingchecked':currentrating>4}"></span>
  </div>
</template>


<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";


  export default {
    props: ["rating"],   
   
    data: function() {
      return { 
          currentrating:this.rating              
      }
    },
    methods: {      
      
      ratingclicked(rate) {  
        if(this.currentrating === rate)
          this.currentrating -=1       
        else
          this.currentrating = rate      
          
        this.$emit("ratingclicked", {
          data: {rating:this.currentrating}
        });        
      }
   
    }

  };
</script>
 
<style>

    .ratingchecked {
        color: orange;
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/RatingSelector.vue